class QuantitySelector extends HTMLElement {
  constructor() {
    super()
  }

  connectedCallback() {
    this.input = this.querySelector('input')
    $(this)
      .find('button[name="increase"]')
      .on('click', this.onPlusButtonClick.bind(this))
    this.decreaseButton = $(this).find('button[name="decrease"]')
    this.decreaseButton.on('click', this.onMinusButtonClick.bind(this))

    this.removeIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15" fill="none">
      <path d="M0.5 3.26685H2H14" stroke="#262626" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M12.5 3.26676V12.6001C12.5 12.9537 12.342 13.2929 12.0607 13.5429C11.7794 13.793 11.3978 13.9334 11 13.9334H3.5C3.10218 13.9334 2.72064 13.793 2.43934 13.5429C2.15804 13.2929 2 12.9537 2 12.6001V3.26676M4.25 3.26676V1.93343C4.25 1.57981 4.40804 1.24067 4.68934 0.990622C4.97064 0.740573 5.35218 0.600098 5.75 0.600098H8.75C9.14783 0.600098 9.52936 0.740573 9.81066 0.990622C10.092 1.24067 10.25 1.57981 10.25 1.93343V3.26676" stroke="#262626" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M5.75 6.6001V10.6001" stroke="#262626" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M8.75 6.6001V10.6001" stroke="#262626" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>`

    this.minusIcon = `<svg width="12" height="2" viewBox="0 0 12 2" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path id="Open" d="M1.26053 0.119862C0.886585 0.119862 0.583496 0.513876 0.583496 1C0.583496 1.48612 0.886585 1.88014 1.26053 1.88014H10.7398C11.1137 1.88014 11.4168 1.48612 11.4168 1C11.4168 0.513876 11.1137 0.119862 10.7398 0.119862H1.26053Z" fill="#D8D8D8"/>
    </svg>`

    const priceElement = $(this).attr('price')
    if (priceElement.length) {
      this.currency = priceElement.substring(0, 1)
      this.price = parseInt(priceElement.substring(1))
      this.updateButtons(this.input.value)
    }

    console.log('this.isCartView()', this.isCartView())
    if (this.isCartView()) {
      subscribe(PUB_SUB_EVENTS.cartItemChange, () => {
        // Set a timeout to match debounce delay time in cart-items component and sync enabling of quantity buttons
        setTimeout(() => {
          this.validateQtyRules(this.input)
        }, 500)
      })
    }
  }

  isCartView() {
    return this.getAttribute('data-view') == 'cart'
  }

  onPlusButtonClick(event) {
    event.preventDefault()
    if (!this.input) {
      return
    }

    $(this).find('button').attr('disabled', true)

    let value = parseInt(this.input.value)
    value = value + 1
    this.onButtonClick(value, event)
  }

  onMinusButtonClick(event) {
    event.preventDefault()
    if (!this.input) {
      return
    }

    $(this).find('button').attr('disabled', true)

    let value = parseInt(this.input.value)
    value = value - 1
    this.onButtonClick(value, event)
  }

  onButtonClick(value, event) {
    if (!this.input) {
      return
    }

    if (this.validateQtyRules(value)) {
      if (!this.isCartView()) {
        this.updateButtons(value)
      }
      this.updatePrice(value)

      const { lineItem } = event.currentTarget.dataset
      const publishEvent = lineItem
        ? `${PUB_SUB_EVENTS.quantityChange}-${lineItem}`
        : PUB_SUB_EVENTS.quantityChange

      publish(publishEvent, {
        data: {
          quantity: value,
        },
      })
    }
  }

  updatePrice() {
    if (!this.input) {
      return
    }
    const priceElement = $(this).find(
      '.prod-wgac-quantity-selector__price-title'
    )
    if (priceElement.length > 0) {
      const quantity = this.input.value
      const newPrice = this.price * quantity
      priceElement.text(this.currency + newPrice.toFixed(2))
    }
  }

  updatePrice(value) {
    if (!this.input) {
      return
    }

    const priceElement = $(this).find(
      '.prod-wgac-quantity-selector__price-title'
    )

    if (priceElement.length > 0) {
      const quantity = value
      const newPrice = this.price * quantity
      priceElement.text(this.currency + newPrice.toFixed(2))
    }
  }

  validateQtyRules(value) {
    if (!this.input) {
      return
    }

    let isValid = true
    if (this.input.min) {
      const min = parseInt(this.input.min)
      if (value < min) {
        isValid = false
      }
    }

    if (this.input.max) {
      const max = parseInt(this.input.max)
      if (value > max) {
        isValid = false
      }
    }

    return isValid
  }

  updateButtons(value) {
    if (this.input.min) {
      const min = parseInt(this.input.min)
      const buttonMinus = $(this).find("button[name='decrease']")
      if (value <= min) {
        buttonMinus.attr('disabled', true)
      } else {
        buttonMinus.removeAttr('disabled')
        if (value >= 1) {
          this.input.value = value
        }
      }
    }

    const allowZero = this.decreaseButton.attr('allow-zero')
    if (allowZero === 'true' && value <= 1) {
      this.decreaseButton.html(this.removeIcon)
      this.decreaseButton.attr('name', 'remove')
      this.decreaseButton.attr('aria-label', 'remove item')
    } else {
      this.decreaseButton.html(this.minusIcon)
      this.decreaseButton.attr('name', 'decrease')
      this.decreaseButton.attr('aria-label', 'Decrease quantity')
    }

    if (this.input.max) {
      const max = parseInt(this.input.max)
      const buttonPlus = $(this).find("button[name='increase']")
      if (value >= max) {
        buttonPlus.attr('disabled', true)
      } else {
        buttonPlus.removeAttr('disabled')
        if (value >= 1) {
          this.input.value = value
        }
      }
    }
  }
}

customElements.define('quantity-selector', QuantitySelector)
